import * as r from "react";
import a from "./atoms-v2851.js";
var o = function(t) {
  var e = r.useRef(t);
  return a(function() {
    e.current = t;
  }), e;
};
export {
  o as default
};
